export const MARKER_LANE_TYPE_COMMENT = 'comment';
export const MARKER_LANE_TYPE_SUBCLIP = 'subclip';
export const MARKER_LANE_TYPE_TIME_BASED_METADATA = 'time_based_metadata';
export const MARKER_LANE_TYPE_TRANSCRIPTION = 'transcription';
export const MARKER_LANE_TYPE_PERSON = 'person';

// Original Iconik colors
// export const COLOR_CODING = {
//   acls: '#bd79fd',
//   collections: '#8bc34a',
//   comments: '#7ee1ff',
//   discovery: '#7c4dff',
//   face_recognition: '#a4e650',
//   files: '#ffb11b',
//   filters: '#f44336',
//   history: '#9c27b0',
//   metadata: '#07dab0',
//   posters: '#e5e619',
//   relations: '#97f5ff',
//   reviews: '#fd8ef1',
//   saved_searches: '#03a9f4',
//   shares: '#f44336',
//   subclips: '#ecb4b4',
//   transcriptions: '#648df6',
//   uploads: '#ffffff',
// } as const;

export const COLOR_CODING = {
  acls: 'var(--color-palette-primary-purple)',
  collections: 'var(--color-palette-primary-green)',
  comments: 'var(--color-palette-primary-teal)',
  discovery: 'var(--color-palette-secondary-indigo)',
  face_recognition: 'var(--color-palette-primary-green)',
  files: 'var(--color-palette-primary-orange)',
  filters: 'var(--color-palette-primary-red)',
  history: 'var(--color-palette-primary-purple)',
  metadata: 'var(--color-palette-primary-turquoise)',
  posters: 'var(--color-palette-primary-yellow)',
  publish: 'var(--color-palette-primary-green)',
  relations: 'var(--color-palette-primary-teal)',
  reviews: 'var(--color-palette-primary-lilac)',
  saved_searches: 'var(--color-palette-primary-teal)',
  shares: 'var(--color-palette-primary-red)',
  subclips: 'var(--color-palette-primary-pink)',
  transcriptions: 'var(--color-palette-primary-blue)',
  cutting_room: 'var(--color-palette-primary-orange)',
  uploads: 'var(--color-palette-primary-inverted)',
} as const;

export const markerLanes = {
  [MARKER_LANE_TYPE_COMMENT]: {
    color: COLOR_CODING.comments,
    primary: true,
  },
  [MARKER_LANE_TYPE_SUBCLIP]: {
    color: COLOR_CODING.subclips,
    icon: 'Svg2022_uad_subclip',
    primary: false,
  },
  [MARKER_LANE_TYPE_TIME_BASED_METADATA]: {
    color: COLOR_CODING.metadata,
    icon: 'Svg2022_uad_time_based_metadata',
    primary: false,
  },
  [MARKER_LANE_TYPE_TRANSCRIPTION]: {
    color: COLOR_CODING.transcriptions,
    icon: 'transcription',
    primary: false,
  },
  [MARKER_LANE_TYPE_PERSON]: {
    color: COLOR_CODING.face_recognition,
    icon: 'face_recognition',
    primary: false,
  },
} as const;
